import {HttpClient} from '@angular/common/http'
import {inject, Injectable, signal} from '@angular/core'
import {toObservable} from '@angular/core/rxjs-interop'
import {ICollectResult, ISamtyckeUser} from '@samtycke/samtycke-bankid-gw'
import {of} from 'rxjs'
import {environment} from '../../environments/environment'
import {LOCAL_STORAGE} from '../0-general/providers'
import {ACCESS_TOKEN_KEY} from '../0-general/shared'

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  public accessToken = signal<ICollectResult | null>(null)
  public accessToken$ = toObservable(this.accessToken)

  public user = signal<ISamtyckeUser | null>(null)

  private readonly storage = inject(LOCAL_STORAGE)
  private readonly http = inject(HttpClient)

  public bootstrap() {
    try {
      this.login(JSON.parse(this.storage.getItem(ACCESS_TOKEN_KEY)!))
    } catch {
      this.logout()
    }
    return of(true)
  }

  public logout(): void {
    this.storage.removeItem(ACCESS_TOKEN_KEY)
    this.accessToken.set(null)
  }

  public login(token: ICollectResult | null): void {
    if (!token) {
      return
    }
    this.storage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(token))
    this.accessToken.set(token)

    const url = `${environment.bankIdGatewayUrl}/self`
    this.http.get<Required<ISamtyckeUser>>(url).subscribe({
      next: user => {
        this.user.set(user)
      }
    })
  }
}
